<header>
  <div class="logo-header">
    <img
      src="assets/images/cbw-logo.png"
      alt="Camp Bow Wow logo"
      class="logo"
    >
  </div>
</header>
<div
  class="reg-body"
  role="main"
>
  <div style="flex: 1 0 auto">
    <app-forgot-password-email
      *ngIf="step === 0"
      (changeStep)="handlePageContent($event)"
      (email)="setEmail($event)"
    ></app-forgot-password-email>
    <app-forgot-password-confirm
      *ngIf="step === 1"
      [email]="email"
    ></app-forgot-password-confirm>
  </div>
  <app-privacy-policy-footer></app-privacy-policy-footer>
</div>